import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PowerBiState, powerbiFeatureKey } from './powerbi.state';

export const selectPowerBiStateRoot =
  createFeatureSelector<PowerBiState>(powerbiFeatureKey);

export const selectAnalyticsReport = createSelector(
  selectPowerBiStateRoot,
  (state) => state.reports.analytics
);

export const selectAnalyticsError = createSelector(
  selectPowerBiStateRoot,
  (state) => state.error
);
